export default {
  receiveCodeText:
    "Click the 'Get Code' button to receive the verification code",
  voiceConfirm: "Voice Verification Code",
  receiveCode: "Get Code",
  securityConfirmText:
    "Security verification is currently disabled and you do not need this section for transactions. You can finalize the transaction by clicking the button below.",
  and: "and",
  email: "Email",
  mobile: "Mobile",
  google: "Google"
};
